import { Svg, type SvgProps } from '../../misc/svg';

import type { JSX } from 'react';

export const Mail = (properties: SvgProps): JSX.Element => (
  <Svg viewBox='0 0 165 156' {...properties}>
    <g>
      <g>
        <g>
          <rect
            width='94.3666'
            height='61.2829'
            rx='4.31373'
            transform='matrix(-0.977676 0.210118 0.217896 0.975972 151.646 0.919922)'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M113.451 39.8534L61.05 24.8789'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M160.964 56.8701L142.172 46.842'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M76.0874 76.616L88.8735 59.7896'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M113.96 39.8531L152.612 4.91262'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <g>
          <path
            d='M74.2691 123.079L79.1477 121.048C80.2344 120.596 81.088 119.72 81.5178 118.625C82.4412 116.27 83.882 112.645 85.2357 109.385C87.429 104.103 93.8096 101.951 95.4047 103.32C96.9999 104.69 92.4138 114.471 91.6162 117.21C90.8187 119.949 88.426 128.165 86.8308 128.948C85.2357 129.731 80.6496 131.882 75.8642 133.643C71.0788 135.404 68.686 135.208 63.9006 134.621C60.0722 134.152 48.3302 131.98 38.7593 130.676C37.2727 130.395 33.3046 130.575 29.325 133.537C25.3454 136.499 7.57033 149.49 5.16895 151.285'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M88.459 126.345C89.7187 125.65 93.6271 123.72 94.7606 122.237C96.1775 120.383 103.971 103.004 104.916 99.9918C105.861 96.9794 106.805 94.6622 103.027 94.8939C100.004 95.0793 96.2562 98.6014 95.2328 100.455'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M98.9355 121.647C99.8837 121.108 102.229 119.562 104.025 117.682C106.27 115.332 113.006 104.465 113.754 102.849C114.502 101.234 112.706 99.9123 109.413 101.968C106.779 103.613 105.934 104.38 105.535 104.82'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M79.9524 111.917C78.0021 110.961 73.3492 108.965 70.3403 108.637C66.5792 108.227 60.9373 107.817 55.5044 105.972C50.0714 104.127 49.6534 103.717 49.0265 101.667C48.3996 99.6163 49.0265 95.7209 50.0713 93.2607'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M51.7429 89.1601C53.2057 87.5199 56.2985 83.2965 56.9671 79.5242C57.8029 74.8089 57.385 70.9136 54.4595 70.5036C51.5341 70.0935 50.2804 73.5789 46.937 77.6792C43.5937 81.7795 38.5785 87.93 32.7276 92.2353C26.8768 96.5407 20.6081 104.536 21.8618 110.687'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M19.3596 111.354L1.01758 121.334'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M27.6621 114.609C29.5774 113.213 34.7214 110.775 39.9753 112.193C46.5427 113.965 56.3936 119.442 60.0055 120.408'
            stroke='#012F33'
            strokeWidth='1.43791'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
      </g>
    </g>
  </Svg>
);
